export default __webpack_public_path__ + "static/media/logo.44014144.svg";